import axios from "./api";
export const getBaseData = async () => {
    const res = await axios.get("/base-data");
    return res.data;
};
//# sourceMappingURL=getBaseData.js.map